import React, { Dispatch, SetStateAction, useState, useEffect } from 'react';
import { WIStep1 } from './wISteps/WIStep1';
import { WIStep2 } from './wISteps/WIStep2';
import { WIStep3 } from './wISteps/WIStep3';
import { WIStep4 } from './wISteps/WIStep4';
import { WondeYearSink } from './WondeYearSink';
import { SyncWondeDataResponse } from './models';

type WondeIntegrationProps = {
  setWondeIntegration: Dispatch<SetStateAction<boolean>>;
  selectedSyncType: string;
  wondeSchoolId: any; 
  syncResponse: SyncWondeDataResponse | null;
};
export type SyncDataOption = ("Class" | "Pupil");

export const WondeIntegration: React.FC<WondeIntegrationProps> = ({ 
  setWondeIntegration,
  selectedSyncType,
  wondeSchoolId,
  syncResponse
}) => {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [syncDataOpts, setSyncDataOpts] = useState<SyncDataOption[]>([]);

  useEffect(() => {
    const syncOptList: SyncDataOption[] = ["Class", "Pupil"];

    setSyncDataOpts(syncOptList);
  }, [selectedSyncType]);

  const currentStepPage = () => {
    switch(currentStep) {
      case 0:
        return (
          <WondeYearSink 
            setCurrentStep={setCurrentStep}
            setWondeIntegration={setWondeIntegration}
            selectedSyncType={selectedSyncType}
            wondeSchoolId={wondeSchoolId}
            syncResponse={syncResponse}
          />
        );
      case 1:
        return (
          <WIStep1 
            setCurrentStep={setCurrentStep}
            setWondeIntegration={setWondeIntegration}
            currentSynOpt={syncDataOpts[0]}
          />
        );
      case 2:
        return (
          <WIStep2 
            setCurrentStep={setCurrentStep}
            setWondeIntegration={setWondeIntegration}
            currentSynOpt={syncDataOpts[0]}
          />
        );
      case 3:
        return (
          <WIStep3 
            setCurrentStep={setCurrentStep}
            setWondeIntegration={setWondeIntegration}
            currentSynOpt={syncDataOpts[0]}
          />
        );
      case 4:
        return (
          <WIStep4 
            setWondeIntegration={setWondeIntegration}
            currentSynOpt={syncDataOpts[0]}
            setCurrentStep={setCurrentStep}
            syncDataOpts={syncDataOpts}
            setSyncDataOpts={setSyncDataOpts}
          />
        );
      default:
        setWondeIntegration(false);
    } 
  };

  return (
    <>
      {currentStepPage()}
    </>
  );
};